export default "__VITE_ASSET__DfA9gnAy__"